import { RESET_DATASET } from 'store';

import { RESET_BOOTSTRAP_CIS } from '../types';
import { SET_PRIMARY_PARAMETER_LEVEL } from './types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_PRIMARY_PARAMETER_LEVEL:
      return action.primaryParameterLevel;
    case RESET_DATASET:
    case RESET_BOOTSTRAP_CIS:
      return null;
    default:
      return state;
  }
};
